(function () {
  'use strict';

  angular.module('tooltip').directive('estTooltip', estTooltip);

  estTooltip.$inject = ['$compile'];

  function estTooltip($compile) {
    return {
      link: link,
      scope: {
        estTooltip: '@',
      },
    };

    function link(scope, elem, attrs) {
      var temp = require('./tooltip.html');
      elem
        .on('mouseenter', function (event) {
          event.stopPropagation();
          if (scope.estTooltip) {
            var compTemp = $compile(temp)(scope);
            $(compTemp).appendTo('body').text(scope.estTooltip);

            compTemp.css({
              top: elem.offset().top - compTemp.height() - 15,
              left:
                elem.offset().left + elem.width() / 2 - compTemp.width() / 2,
            });

            compTemp.fadeIn(250);
          }
        })
        .on('mouseleave', function (event) {
          $('.b-tooltip').fadeOut(250, function () {
            $(this).remove();
          });
        });
    }
  }
})();
